import { temp, ui } from "../../../../../../interfaces/interfaces";
import { InitialStageState } from "@utils/validation";
import { AddressUtils } from "@utils/address";

export const ACTIVE_STEPS = {
    JOB_SEARCH: 0,
    PROPERTY_SEARCH: 1,
    AREA_COVERAGE: 2,
    REQUIRED_OPTIONS: 3
}

export const ACTIONS = {
    SET_JOB_TYPE_STATE: (payload: boolean) => ({ id: 0, type: "SET_JOB_TYPE_STATE", payload }),
    SET_REQUIRED_OPTIONS_STATE: (payload: boolean) => ({ id: 1, type: "SET_REQUIRED_OPTIONS_STATE", payload }),
    SET_AREA_COVERAGE_STATE: (payload: boolean) => ({ id: 2, type: "SET_AREA_COVERAGE_STATE", payload }),
    SET_PROPERTY_SEARCH_STATE: (payload: boolean) => ({ id: 3, type: "SET_PROPERTY_SEARCH_STATE", payload }),
}

export const initialStageState: InitialStageState = {
    0: {
        id: 0,
        title: "JobSearch",
        complete: false,
        label: 'Select job type',
        description: `You have to select job type by either seraching by job name or by narrowing trade and category until you can find matching job type.`,
    },
    1: {
        id: 1,
        title: "RequiredQuestions",
        complete: false,
        label: 'Required questions',
        description:
            'Answer required questions specific for this job type.',
    },
    2: {
        id: 2,
        title: "AddressSearch",
        complete: false,
        label: 'Search for property address',
        description:
            'Type the postcode and click search icon to find property address.',
    },
    3: {
        id: 3,
        title: "CoverageCheck",
        complete: false,
        label: 'Check Coverage',
        description:
            'If there is coverage go to next step',
    },
}

export const reducer = (state: InitialStageState, action: { type: string; id: number; payload?: boolean }) => {
    switch (action.type) {
        case "SET_JOB_TYPE_STATE":
            const job_state = state[action.id].complete

            if (!job_state && action.payload) {
                return {
                    ...state, [action.id]: { ...state[action.id], complete: true }
                }
            }
            if (job_state && !action.payload) {
                return {
                    ...state, [action.id]: { ...state[action.id], complete: false }
                }
            }
            return state

        case "SET_PROPERTY_SEARCH_STATE":
            const property_search_state = state[action.id].complete
            if (!property_search_state && action.payload) {
                return {
                    ...state, [action.id]: { ...state[action.id], complete: true }
                }
            }
            if (property_search_state && !action.payload) {
                return {
                    ...state, [action.id]: { ...state[action.id], complete: false }
                }
            }
            return state

        case "SET_AREA_COVERAGE_STATE":
            const area_coverage_state = state[action.id].complete
            const isPostcodeSearched = temp.ProblemAddressSearchDone
            if (!area_coverage_state && action.payload) {
                return {
                    ...state, [action.id]: { ...state[action.id], complete: true, description: initialStageState[action.id].description }
                }
            }
            if (area_coverage_state && !action.payload) {
                return {
                    ...state, [action.id]: { ...state[action.id], complete: false, description: initialStageState[action.id].description }
                }
            }
            if (!action.payload && ui.ProblemInputPostcode && AddressUtils.validatePostcode(ui.ProblemInputPostcode) && state[ACTIVE_STEPS.PROPERTY_SEARCH].complete && isPostcodeSearched) {
                return {
                    ...state, [action.id]: { ...state[action.id], description: "There is no coverage please fail the booking or try different address if incorrect!" }
                }
            }
            //Customer Realised Already Called Us
            return state

        case "SET_REQUIRED_OPTIONS_STATE":
            const required_options_state = state[action.id].complete
            if (!required_options_state && action.payload) {

                return {
                    ...state, [action.id]: { ...state[action.id], complete: true }
                }
            }
            if (required_options_state && !action.payload) {
                return {
                    ...state, [action.id]: { ...state[action.id], complete: false }
                }
            }
            return state

        default:
            return state;
    }
};
